import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "./usePermission";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
  fallbackPath?: string;
}

/**
 * Protected Route Component
 * Wraps route components and checks if user has required permissions
 * Redirects to fallback path if user doesn't have access
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions = [],
  fallbackPath = "/dashboard",
}) => {
  const { canAccessRoute, isFullAccess } = usePermission();

  // super_admin and admin always have access
  if (isFullAccess) {
    return <>{children}</>;
  }

  // Check if user has required permissions
  const hasAccess = canAccessRoute(requiredPermissions);

  if (!hasAccess) {
    // Redirect to fallback path if no access
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
